// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	// host: 'https://gcompany-admin-toolkit-tst.appspot.com/api',
	host: 'https://toolkit.g.company/api',
	login: '/login',
	uploadSettings: '/upload-settings',
	fotgotPassword: '/forgot-password',
	resetPassword: '/reset-password',
	countires: '/static/countries.json',
	fileupload: '/fileupload',
	deleteAttachment: '/filedelete',
	clientSignup: '/client-signup',
	authorizeAccess: '/authorize-access',
	authorizeAccessMenu: '/authorize-access/menu',
	googleUserList: '/common/user-list',
	googleGroupList: '/common/group-list',
	addForwardingEmail: '/forwarding/forwarding-email',
	deleteForwardingEmail: '/forwarding/forwarding-email',
	imageHandler: '/common/image',
	exportFullReport: '/report/export/full',
	exportReport: '/report/export',
	emailReport: '/report/email',
	spreadsheetBaseUrl: 'https://docs.google.com/spreadsheets/d/',
	csvBaseUrl: 'https://drive.google.com/open?id=',
	vacationResponder: '/vacation-responder',
	delegations: '/delegations',
	delegationsReverse: '/delegations-reverse',
	delegationsCalendar: '/delegations-calendar',
	delegationsCalendarReverse: '/delegations-calendar-reverse',
	commonSignature: '/common-signature',
	signatureViaTemplates: '/signatures-templates',
	customSignatures: '/custom-signatures',
	forwarding: '/forwarding',
	report: '/report',
	drivePolicy: '/drive-policy',
	offboarding: '/offboarding',
	offboardingGetProfileList: '/offboarding/profile-list',
	offboardingGetScheduleJob: '/offboarding/schedule-job',
	offboardingGetScheduleList: '/offboarding/schedule',
	offboardingSaveScheduleList: '/offboarding/schedule',
	offboardingDeleteScheduleList : '/offboarding/schedule-delete',
	onboarding: '/onboarding',
	sendAs: '/send-as',
	groupManagement: '/group-management',
	migrateEmail: '/migrate-email',
	editHTMLTemplates: '/edit-html-templates',
	editSecurityRights: '/edit-security-rights',
	securityRightsAddUser: '/edit-security-rights/user',
	getAccessRight: '/edit-security-rights/access-right',
	log: '/log',
	editSignatureData: '/edit-signature-data',
	editSettings: '/edit-settings',
	deleteHTMLTemplates: '/delete-html-templates',
	clientIdGoogleLoginOauth: '99078639983-i02287smfp72ghr2ddsq6939aqrc5ghd.apps.googleusercontent.com',
	developerKey: 'AIzaSyAKAaFzF8Tape2r0mlQqmljjogHdArd8Ig',
	existUserList: '/common/exist-user-list',
	existUserLiteList: '/common/exist-user-lite-list',
	editOtherSettings: '/edit-settings/other-settings',
	manualSyncUserList: '/edit-settings/manual-sync-user-list',
	manualSyncDriveList: '/edit-settings/manual-sync-drive-list',
	manualSyncOrgUnitListHref: '/edit-settings/manual-sync-orgunit-list',
	manualSyncGroupListHref: '/edit-settings/manual-sync-group-list',
	orgUnitList: '/common/orgunit-list',
	orgUnitListByUser: '/common/orgunit-list-by-user',
	adminListByOrgUnit: '/common/admin-list-by-user-org-unit',
	exportSignatureData: '/export-signature-data',
	domainList: '/common/domain-list',
	elasticUserList: '/common/elastic-user-list',
	elasticGroupList: '/common/elastic-group-list',
	elasticDriveList: '/common/elastic-drive-list',
	licenseList: '/common/license-list',
	userInformation: '/common/get-detail-user-info',
	userEmailLabel: '/common/user-email-label',
	contacts: '/contacts',
	submitFeedback: '/submit-feedback',
	releaseNoteURL:"https://docs.google.com/document/d/e/2PACX-1vQbAZj0EhOIywipSK5jrSMn5zu54wmjII-DQf2g5n6l_47clszWkLI2aOfGgnz_3V_078hqLo_wNfg3/pub?embedded=true",
	checkUserToken: '/common/check-user-token',

};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
